import { EDjangoAppsEndpoints } from '../enums/EDjangoAppsEndpoints';
import type { ISectorDetailArgs } from '../models/ISectorDetailArgs';
import { type PlotlyResponse } from '../models/PlotlyModel';
import { type TPandasTable } from '../models/TPandasTable';
import ApiService from './apiService';

export default class SvSectorPerformanceServices extends ApiService {
  static async getSectorDistributionPlot(startDate?: string, endDate?: string) {
    return await super.get<PlotlyResponse>(EDjangoAppsEndpoints.sectorPerformance, 'sector-distribution/plot', {
      startDate,
      endDate
    });
  }

  static async getSectorDistributionTable(date?: string) {
    return await super.get<TPandasTable>(EDjangoAppsEndpoints.sectorPerformance, 'sector-distribution/table', {
      date
    });
  }

  // respective methods for index total return service
  static async getIndexTotalReturnPlot(startDate: string, endDate: string, weight: string, index: string) {
    return await super.get<PlotlyResponse>(EDjangoAppsEndpoints.sectorPerformance, 'index-total-return/plot', {
      startDate,
      endDate,
      index,
      weight
    });
  }

  static async getIndexTotalReturnTable(startDate: string, endDate: string, weight: string, index: string) {
    return await super.get<TPandasTable>(EDjangoAppsEndpoints.sectorPerformance, 'index-total-return/table', {
      startDate,
      endDate,
      index,
      weight
    });
  }

  // respective methods for sector total return service
  static async getSectorTotalReturnPlot(startDate: string, endDate: string, weight: string, index: string) {
    return await super.get<PlotlyResponse>(EDjangoAppsEndpoints.sectorPerformance, 'sector-total-return/plot', {
      startDate,
      endDate,
      index,
      weight
    });
  }

  static async getSectorTotalReturnTable(startDate: string, endDate: string, weight: string, index: string) {
    return await super.get<TPandasTable>(EDjangoAppsEndpoints.sectorPerformance, 'sector-total-return/table', {
      startDate,
      endDate,
      index,
      weight
    });
  }

  // respective method for sector details service
  static async getSectorDetailPlots(args: ISectorDetailArgs) {
    const index = `${args.interval}_${args.selection}_${args.noCompanies}`;

    return await super.get<{
      sector_plot: PlotlyResponse;
      all_plot: PlotlyResponse;
    }>(EDjangoAppsEndpoints.sectorPerformance, 'sector-details/plots', {
      index,
      weight: args.weight,
      sector: args.sector,
      year: args.year
    });
  }

  static async getSectorDetailTables(args: ISectorDetailArgs) {
    const index = `${args.interval}_${args.selection}_${args.noCompanies}`;

    return await super.get<{
      monthly_returns: TPandasTable;
      monthly_performance: TPandasTable;
      annual_performance: TPandasTable;
    }>(EDjangoAppsEndpoints.sectorPerformance, 'sector-details/tables', {
      index,
      weight: args.weight,
      sector: args.sector,
      year: args.year
    });
  }
}
